import apiClient, { extractData, handleApiError } from './api.js';

export class StaffService {
  /**
   * Add a new staff member
   * POST /api/v1/staff
   */
  static async addStaff({ phone, name, pin, outletId }) {
    try {
      const response = await apiClient.post('/staff', {
        phone,
        name,
        pin,
        outlet_id: outletId,
      });
      return extractData(response);
    } catch (error) {
      console.error('Error adding staff:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * List all staff members for an outlet
   * GET /api/v1/staff?outlet_id=...
   */
  static async listStaff(outletId) {
    try {
      const response = await apiClient.get('/staff', {
        params: { outlet_id: outletId },
      });
      const data = extractData(response);
      return data.staff || data || [];
    } catch (error) {
      console.error('Error listing staff:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Remove a staff member
   * DELETE /api/v1/staff/{userId}
   */
  static async removeStaff(userId) {
    try {
      const response = await apiClient.delete(`/staff/${userId}`);
      return extractData(response);
    } catch (error) {
      console.error('Error removing staff:', error);
      throw new Error(handleApiError(error));
    }
  }
}
